import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import axios from '../config/axios';
import { getApiUrl } from '../config/environment';

interface PaymentNotificationState {
  active: boolean;
  type?: string;
  client_name?: string;
  plan_expiration_date?: string;
  days_until_expiration?: number;
  message?: string;
  timestamp?: string;
}

interface PaymentNotificationContextType {
  notification: PaymentNotificationState;
  refreshNotification: () => Promise<void>;
}

const PaymentNotificationContext = createContext<PaymentNotificationContextType | undefined>(undefined);

export const usePaymentNotification = () => {
  const context = useContext(PaymentNotificationContext);
  if (!context) {
    throw new Error('usePaymentNotification must be used within PaymentNotificationProvider');
  }
  return context;
};

interface PaymentNotificationProviderProps {
  children: ReactNode;
}

export const PaymentNotificationProvider: React.FC<PaymentNotificationProviderProps> = ({ children }) => {
  const [notification, setNotification] = useState<PaymentNotificationState>({
    active: false
  });

  const refreshNotification = async () => {
    try {
      // Usar getApiUrl() que já retorna a URL completa com /api/v1
      const response = await axios.get(getApiUrl('/payment-notification/status'));
      
      if (response.data.success) {
        setNotification(response.data.data || { active: false });
      }
    } catch (error) {
      console.error('Erro ao buscar status da notificação:', error);
      // Em caso de erro, manter estado atual
    }
  };

  useEffect(() => {
    // Buscar status inicial
    refreshNotification();

    // Atualizar a cada 30 segundos
    const interval = setInterval(() => {
      refreshNotification();
    }, 30000);

    return () => clearInterval(interval);
  }, []);

  return (
    <PaymentNotificationContext.Provider value={{ notification, refreshNotification }}>
      {children}
    </PaymentNotificationContext.Provider>
  );
};




